/**
 * 侧边菜单栏状态
 */
export const enum SIDEBAR_STATUS {
  /**
   * 关闭
   */
  CLOSE = '0',
  /**
   * 开启
   */
  OPEN = '1',
}

/**
 * 布尔常量
 */
export const enum BOOL {
  FALSE = '0',
  TRUE = '1'
}

/**
 * 响应状态码
 */
export const enum RESPONSE_STATUS_CODE {
  /**
   * 成功
   */
  SUCCESS = '00000',
  /**
   * 客户端错误前缀
   */
  CLIENT_PREFIX_ERROR = 'C',
  /**
   * 客户端错误
   */
  CLIENT_ERROR = 'C0000',
  /**
   * 访问未授权
   */
  UNAUTHORIZED = 'C0301',
  /**
   * 参数错误
   */
  INVALID_PARAM = 'C0400',
  /**
   * 服务端错误前缀
   */
  SERVER_PREFIX_ERROR = 'S',
  /**
   * 服务端错误
   */
  SERVER_ERROR = 'S0000',
  /**
   * 业务异常前缀
   */
  BUSINESS_PREFIX_ERROR = 'B',
  /**
   * 业务异常
   */
  BUSINESS_ERROR = 'B0000'
}
